import {
  FormControlConfig,
  IFormControlConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoCheckboxConfig extends IFormControlConfig {
  type?: 'checkbox';
  checkboxStyleClass?: string;
  value?: any;
}

export class EoCheckboxConfig
  extends FormControlConfig
  implements IEoCheckboxConfig
{
  override type?: 'checkbox';
  checkboxStyleClass?: string;
  value?: any;

  constructor();
  constructor(obj: IEoCheckboxConfig);
  constructor(obj?: IEoCheckboxConfig) {
    super(obj as IFormControlConfig);
    this.type = 'checkbox';
    if (obj?.value) this.value = obj.value;
  }
}
